import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { useApi } from 'app/shared/contexts/api';
import { useBuilding } from 'app/shared/contexts/building';

export const getSanitizedTagsQueryKey = (buildingUuid: string): QueryKey => ['sanitized-tags', buildingUuid];

export const useSanitizedTagsQuery = () => {
  const { building } = useBuilding();
  const { apiUrl, getAuthHeaders } = useApi() as unknown as {
    apiUrl: string;
    getAuthHeaders: () => Promise<{ Authorization: string }>;
  };

  return useQuery({
    queryKey: getSanitizedTagsQueryKey(building?.uuid ?? ''),
    queryFn: async ({ signal }): Promise<{ data: unknown[] }> => {
      const headers = await getAuthHeaders();
      const payload = await apiRequest<{ data: { sanitized_tags: unknown[] } }, void, void>({
        url: `${apiUrl}/content/tenant/v3/buildings/${building?.uuid}/sanitized-tags`,
        method: HttpMethod.GET,
        headers,
        signal,
      });

      return payload.isEmpty() ? { data: [] } : { data: payload.data.data.sanitized_tags };
    },
  });
};
